<template>
	<div class="view-index-v">
		<div class="list-caption">找到约{{listData.length}}条记录</div>
		<div class="search-item" v-for="(item, idx) in listData" :key="idx"  @click="onItemClick(item)">
			<div class="inline-between inner">
				<div class="content" v-html="item.aname"></div>
				<i class="el-icon-d-arrow-right"></i>
			</div>
		</div>
	</div>
</template>

<script>
	import IndexMixin from './mixins/index.js';
	export default {
		name: 'IndexV',
		mixins: [IndexMixin],
		data() {
			return {
				
			}
		},
		mounted() {
			
		},
		methods: {
			
		}
	}
</script>

<style scoped lang="less">
	.view-index-v {
		width: 100%;
		padding: calc(50px * var(--scale-rate)) calc(52px * var(--scale-rate)) 0;
		overflow-x: hidden;
		
		.list-caption {
			font-size: 22px;
			transform: scale(var(--scale-rate));
			transform-origin: left center;
			height: calc(25px * var(--scale-rate));
			margin-bottom: 20px;
		}
		
		.search-item {
			margin-bottom: calc(35px * var(--scale-rate));
			width: calc(100% / var(--scale-rate));
			height: calc(75px * var(--scale-rate));
			cursor: pointer;
			
			.inner {
				transform: scale(var(--scale-rate));
				transform-origin: left top;
				height: 75px;
				font-size: 30px;
				line-height: 75px;
				font-weight: 300;
				border-bottom: 1px solid rgb(39, 38, 54); 
			}
			.content {
				span {
					color: rgb(49, 75, 137);
				}
			}
		}
	}
</style>